import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaFolderOpen } from "react-icons/fa";
import { Table, Dropdown, Menu, notification, Modal } from "antd";
import axios from "axios";

import ModalLoading from "../../../../shared/components/Modals/ModalLoading";
import { montarIcon } from "../../../../shared/utils/Drive/file/getFileIcon";

import DrawerEstudoIranduba from "../../../Atendimentos/Estudos/Drawers/DrawerEstudoIranduba";
import DrawerEstudoIrandubaFundamental from "../../../Atendimentos/Estudos/Drawers/DrawerEstudoIrandubaFundamental";
import DrawerEstudoIrandubaPreEscola from "../../../Atendimentos/Estudos/Drawers/DrawerEstudoIrandubaPreEscola";
import DrawerEstudoIrandubaAEE from "../../../Atendimentos/Estudos/Drawers/DrawerEstudoIrandubaAEE";

import DrawerPlanoPEI from "../../../Atendimentos/Planos/Drawers/DrawerPlanoPEI";

import ModalViewer from "../../../../shared/components/Modals/ModalViewer";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const RAIZ = { id: null, nome: "Todos os Alunos" };

const TabelaPastas = ({ pastas, onDeleteFolder, onRefresh }) => {
    const [pastaAtualId, setPastaAtualId] = useState(null);
    const [pastaSelecionadaId, setPastaSelecionadaId] = useState(null);
    const [estudoSelecionadoId, setEstudoSelecionadoId] = useState(null);
    const [planoSelecionadoId, setPlanoSelecionadoId] = useState(null);

    const [visibleDrawerEstudo, setVisibleDrawerEstudo] = useState(false);
    const [visibleDrawerEstudoFundamental, setVisibleDrawerEstudoFundamental] = useState(false);
    const [visibleDrawerEstudoPreEscola, setVisibleDrawerEstudoPreEscola] = useState(false);
    const [visibleDrawerEstudoAEE, setVisibleDrawerEstudoAEE] = useState(false);

    const [visibleDrawerPEI, setVisibleDrawerPEI] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [docs, setDocs] = useState([]);

    const gerarPdf = id => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "api/pdf/formulario-caso",
            params: {
                id
            }
        })
            .then(response => {
                const { url, fileName } = response.data;

                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const gerarPdfPEI = id => {
        setIsLoading(true);
        axios({
            method: "get",
            url: "/api/pdf/formulario-plano-atendimento-pei",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso"),
                planoId: id,
                turmaRegular: true
            }
        })
            .then(response => {
                const { url, fileName } = response.data;
                setDocs([{ uri: url, fileName }]);
                setModalVisible(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível gerar documento.");
            })
            .finally(() => setIsLoading(false));
    };

    const onFileEstudoAdded = estudoId => {
        axios({
            method: "post",
            url: "/api/ensino-especial/adicionar-ficheiro-estudo",
            data: {
                pastaId: pastaSelecionadaId,
                estudoId
            }
        })
            .then(() => {
                onRefresh();
                setVisibleDrawerEstudo(false);
                setVisibleDrawerEstudoFundamental(false);
                setVisibleDrawerEstudoPreEscola(false);
                setVisibleDrawerEstudoAEE(false);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data ?? "Não foi possível adicionar o estudo. Tenta novamente.");
            });
    };

    const onFilePlanoAdded = planoId => {
        axios({
            method: "post",
            url: "/api/ensino-especial/adicionar-ficheiro-plano",
            data: {
                pastaId: pastaSelecionadaId,
                planoId
            }
        })
            .then(() => {
                onRefresh();
                setVisibleDrawerPEI(false);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data ?? "Não foi possível adicionar o plano. Tenta novamente.");
            });
    };

    const onFileUpdated = () => {
        onRefresh();
        setEstudoSelecionadoId(null);
        setPlanoSelecionadoId(null);
        setVisibleDrawerEstudo(false);
        setVisibleDrawerEstudoFundamental(false);
        setVisibleDrawerEstudoPreEscola(false);
        setVisibleDrawerPEI(false);
        setVisibleDrawerEstudoAEE(false);
    };

    const excluirPasta = pastaId => {
        confirm({
            title: "Pretende excluir esta pasta?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/ensino-especial/excluir-pasta",
                    params: {
                        pastaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Pasta excluída com sucesso.");
                        onDeleteFolder();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            error.response?.data ?? "Não foi possível excluir a pasta. Tenta novamente."
                        );
                    });
            }
        });
    };

    const editarFicheiro = (estudoId, tipoEstudo, planoId, tipoPlano) => {
        console.log("editarFicheiro", estudoId, tipoEstudo, planoId, tipoPlano);
        if (tipoEstudo === "estudo_caso_infantil") {
            setEstudoSelecionadoId(estudoId);
            setVisibleDrawerEstudo(true);
        } else if (tipoEstudo === "estudo_caso_infantil_pre_escola") {
            setEstudoSelecionadoId(estudoId);
            setVisibleDrawerEstudoPreEscola(true);
        } else if (tipoEstudo === "estudo_caso_aee") {
            setEstudoSelecionadoId(estudoId);
            setVisibleDrawerEstudoAEE(true);
        } else if (tipoEstudo === "estudo_caso_fundamental") {
            setEstudoSelecionadoId(estudoId);
            setVisibleDrawerEstudoFundamental(true);
        } else if (tipoPlano === "plano_atendimento_especializado_pei") {
            setPlanoSelecionadoId(planoId);
            setVisibleDrawerPEI(true);
        }
    };

    const excluirFicheiro = ficheiroId => {
        confirm({
            title: "Pretende excluir este ficheiro?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/ensino-especial/excluir-ficheiro",
                    params: {
                        ficheiroId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Ficheiro excluído com sucesso.");
                        onDeleteFolder();
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            error.response?.data ?? "Não foi possível excluir o ficheiro. Tenta novamente."
                        );
                    });
            }
        });
    };

    const MontarOpcoesMenu = record => {
        if (record.tipo !== "pasta") {
            return (
                <Menu>
                    <Menu.Item>
                        <Link to="#" onClick={() => (record.estudoId ? gerarPdf(record.estudoId) : gerarPdfPEI(record.planoId))}>
                            Descarregar
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link to="#" onClick={() => editarFicheiro(record.estudoId, record.tipoEstudo, record.planoId, record.tipoPlano)}>
                            Editar
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link to="#" onClick={e => excluirFicheiro(record.id)}>
                            Excluir
                        </Link>
                    </Menu.Item>
                </Menu>
            );
        } else {
            const isTurmaEI = localStorage.getItem("header_codigo") === "EI";

            if (isTurmaEI) {
                return (
                    <Menu>
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={() => {
                                    setPastaSelecionadaId(record.id);
                                    setVisibleDrawerEstudoAEE(true);
                                }}
                            >
                                Estudo de Caso Descritivo
                            </Link>
                        </Menu.Item>
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={() => {
                                    setPastaSelecionadaId(record.id);
                                    setVisibleDrawerEstudo(true);
                                }}
                            >
                                Estudo de Caso e Fase Escolar (Creche)
                            </Link>
                        </Menu.Item>
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={() => {
                                    setPastaSelecionadaId(record.id);
                                    setVisibleDrawerEstudoPreEscola(true);
                                }}
                            >
                                Estudo de Caso e Fase Escolar (Pré-Escola)
                            </Link>
                        </Menu.Item>
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={() => {
                                    setPastaSelecionadaId(record.id);
                                    setVisibleDrawerPEI(true);
                                }}
                            >
                                PEI
                            </Link>
                        </Menu.Item>
                        <Menu.Item>
                            <Link to="#" onClick={e => excluirPasta(record.id)}>
                                Excluir
                            </Link>
                        </Menu.Item>
                    </Menu>
                );
            }

            return (
                <Menu>
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setPastaSelecionadaId(record.id);
                                setVisibleDrawerEstudoAEE(true);
                            }}
                        >
                            Estudo de Caso Descritivo
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setPastaSelecionadaId(record.id);
                                setVisibleDrawerEstudoFundamental(true);
                            }}
                        >
                            Estudo de Caso e Fase Escolar
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link
                            to="#"
                            onClick={() => {
                                setPastaSelecionadaId(record.id);
                                setVisibleDrawerPEI(true);
                            }}
                        >
                            PEI
                        </Link>
                    </Menu.Item>
                    <Menu.Item>
                        <Link to="#" onClick={e => excluirPasta(record.id)}>
                            Excluir
                        </Link>
                    </Menu.Item>
                </Menu>
            );
        }
    };

    const pastaAtual = pastas.find(p => p.id === pastaAtualId) || null;

    const dataSource = pastaAtual
        ? (pastaAtual.ficheiros || []).map(f => ({ ...f, tipo: "ficheiro" }))
        : pastas.map(p => ({ ...p, tipo: "pasta" }));

    const breadcrumb = pastaAtual ? [RAIZ, { id: pastaAtual.id, nome: pastaAtual.nome }] : [RAIZ];

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (record.tipo === "pasta") {
                    return (
                        <span onClick={() => setPastaAtualId(record.id)} className="nome-ficheiro-icon">
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        style={{ color: "rgba(0,0,0,0.65)" }}
                        className="nome-ficheiro-icon"
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "",
            dataIndex: "",
            width: 50,
            render: (text, record) => {
                return (
                    <Dropdown overlay={MontarOpcoesMenu(record)} placement="bottomLeft" trigger={["click"]}>
                        <a className="botao-icon-configs" onClick={e => e.preventDefault()}>
                            <i className="fas fa-cog" />
                        </a>
                    </Dropdown>
                );
            }
        }
    ];

    return (
        <>
            <div className="area-drive" style={{ marginTop: "20px" }}>
                <div className="breadcrumb">
                    {breadcrumb.map((item, index) => (
                        <span key={item.id}>
                            <span style={{ cursor: "pointer", fontWeight: "bold" }} onClick={() => setPastaAtualId(item.id)}>
                                {item.nome}
                            </span>

                            {index < breadcrumb.length - 1 && " / "}
                        </span>
                    ))}
                </div>
                <div className="desktop-only">{dataSource && <Table className="tabela" dataSource={dataSource} columns={columns} />}</div>
            </div>
            <DrawerEstudoIrandubaAEE
                id={estudoSelecionadoId}
                pastaId={pastaSelecionadaId}
                visible={visibleDrawerEstudoAEE}
                atualizarListagem={estudoId => (estudoSelecionadoId ? onFileUpdated() : onFileEstudoAdded(estudoId))}
                onClose={() => setVisibleDrawerEstudoAEE(false)}
            />
            <DrawerEstudoIranduba
                id={estudoSelecionadoId}
                pastaId={pastaSelecionadaId}
                visible={visibleDrawerEstudo}
                atualizarListagem={estudoId => (estudoSelecionadoId ? onFileUpdated() : onFileEstudoAdded(estudoId))}
                onClose={() => setVisibleDrawerEstudo(false)}
            />
            <DrawerEstudoIrandubaFundamental
                id={estudoSelecionadoId}
                pastaId={pastaSelecionadaId}
                visible={visibleDrawerEstudoFundamental}
                atualizarListagem={estudoId => (estudoSelecionadoId ? onFileUpdated() : onFileEstudoAdded(estudoId))}
                onClose={() => setVisibleDrawerEstudoFundamental(false)}
            />
            <DrawerEstudoIrandubaPreEscola
                id={estudoSelecionadoId}
                pastaId={pastaSelecionadaId}
                visible={visibleDrawerEstudoPreEscola}
                atualizarListagem={estudoId => (estudoSelecionadoId ? onFileUpdated() : onFileEstudoAdded(estudoId))}
                onClose={() => setVisibleDrawerEstudoPreEscola(false)}
            />
            <DrawerPlanoPEI
                id={planoSelecionadoId}
                pastaId={pastaSelecionadaId}
                visible={visibleDrawerPEI}
                atualizarListagem={planoId => (planoSelecionadoId ? onFileUpdated() : onFilePlanoAdded(planoId))}
                onClose={() => setVisibleDrawerPEI(false)}
            />
            <ModalLoading visible={isLoading} text="A gerar documento..." />
            <ModalViewer visible={modalVisible} docs={docs} onCancel={() => setModalVisible(false)} />
        </>
    );
};

export default TabelaPastas;
